/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RemoteJobRunStatusFromJSON, RemoteJobRunStatusToJSON, } from './';
export function RemoteJobRunRepresentationFromJSON(json) {
    return RemoteJobRunRepresentationFromJSONTyped(json, false);
}
export function RemoteJobRunRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        uuid: json['uuid'],
        startedAt: new Date(json['startedAt']),
        remoteJobId: json['remoteJobId'],
        status: RemoteJobRunStatusFromJSON(json['status']),
        logs: json['logs'],
    };
}
export function RemoteJobRunRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        uuid: value.uuid,
        startedAt: value.startedAt.toISOString().substr(0, 10),
        remoteJobId: value.remoteJobId,
        status: RemoteJobRunStatusToJSON(value.status),
        logs: value.logs,
    };
}
